import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ClientsService } from '../views/clients/services/clients.service';

export const canActivateClientGuard: CanActivateFn = (route) => {
  const id = route.paramMap.get('clientId');
  const router = inject(Router);
  const snackbar = inject(MatSnackBar);
  const clientSvc = inject(ClientsService);

  if (!id) return of(router.createUrlTree(['/clients']));

  return clientSvc.getCachedClient(id).pipe(
    map((client) =>
      client.deleteAt ? router.createUrlTree(['/clients']) : true
    ),
    catchError((error) => {
      const errorCode = error?.error?.detail?.errorCode;

      if (error.status === 404 && errorCode === 'CLIENT_NOT_FOUND') {
        snackbar.open(
          'Deze cliënt is niet meer beschikbaar.',
          'OK'
        );
      } else if (error.status === 403 && errorCode === 'CLIENT_USER_NOT_PERMITTED') {
        snackbar.open(
          'Je hebt geen toegang tot deze cliënt.',
          'OK'
        );
      } else {
        snackbar.open(
          'Er gaat iets fout met het ophalen van de cliënt. Probeer het later nog eens.',
          'OK'
        );
      }

      return of(router.createUrlTree(['/clients']));
    })
  );
};

